import { RadioButton, type RadioButtonProps } from "@common/controls/Inputs/Radio/index";

import "./style.less";

export { type RadioButtonProps };
export default RadioButton;
